import { useState } from 'react';
import { Link, router } from '@inertiajs/react';
import TeacherShell, { TeacherPageHeader } from '../../../components/layout/TeacherShell';
import { Card, Button, Input, Textarea } from '../../../components/ui';

export default function AtlasMapSetsNew({ map_set = {} }) {
  const [name, setName] = useState(map_set.name || '');
  const [description, setDescription] = useState(map_set.description || '');
  const [saving, setSaving] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || saving) return;
    setSaving(true);
    router.post(
      '/teacher/atlas_map_sets',
      { atlas_map_set: { name: name.trim(), description: description.trim() || null } },
      { onFinish: () => setSaving(false) }
    );
  };

  return (
    <TeacherShell scrollTitle="New Map Set">
      <TeacherPageHeader
        title="New Map Set"
        backLink="/teacher/atlas_map_sets"
        backLabel="Map Sets"
      />

      <div className="max-w-lg">
        <Card className="p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Name <span className="text-red-500">*</span>
              </label>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. German Unification"
                required
                autoFocus
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Description
              </label>
              <Textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={3}
                placeholder="Optional"
              />
            </div>

            <div className="flex items-center gap-3 pt-1">
              <Button type="submit" disabled={saving || !name.trim()}>
                {saving ? 'Creating…' : 'Create map set'}
              </Button>
              <Link href="/teacher/atlas_map_sets">
                <Button type="button" variant="secondary">Cancel</Button>
              </Link>
            </div>
          </form>
        </Card>
      </div>
    </TeacherShell>
  );
}
